import styled from 'styled-components';

const UnassignWarningModalInner = styled.div`
  padding: 10px;
  width: 320px;
  height: 200px;
  background-color: white;
  border-radius: 4px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;

  & div[class*="ButtonWrapper"] {
    height: 30px;
  }
  
  h1 {
    font-size: 18px;
  }
`;

export default UnassignWarningModalInner;


// WEBPACK FOOTER //
// ./components/footer/unassign-button/unassign-warning-modal/styled.js